<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="按门店" name="store">
        <search-form-template
          ref="storeTemplate"
          :searchOptions="storeSearchOptions"
          :toolConfig="toolConfig"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          @btnCommon="btnCommon"
        ></search-form-template>
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template class="charts-box" ref="storeEcharts"
                              :picOption="storeEcharts">
            </echarts-template>
          </div>
          <table-template ref="store"
                          :tableOptions="storeReportTable">
          </table-template>
        </div>
      </el-tab-pane>

      <el-tab-pane label="按分类" name="category">
        <search-form-template
          ref="categoryTemplate"
          :searchOptions="categorySearchOptions"
          :toolConfig="toolConfig"
          @searchSubmit="categorysearchSubmit"
          @clear="clearSearch"
          @btnCommon="btnCommon"
        ></search-form-template>
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template class="charts-box-category" ref="categoryEcharts"
                              :picOption="categoryEcharts">
            </echarts-template>
          </div>
          <table-template ref="category"
                          :tableOptions="categoryTable"
          ></table-template>
        </div>
      </el-tab-pane>
      <el-tab-pane label="按供应商" name="merchant">
        <search-form-template
          ref="merchantTemplate"
          :searchOptions="merchantSearchOptions"
          :toolConfig="toolConfig"
          @searchSubmit="merchantsearchSubmit"
          @clear="clearSearch"
          @btnCommon="btnCommon"
        ></search-form-template>
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template class="charts-box-merchant" ref="merchantEcharts"
                              :picOption="merchantEcharts">
            </echarts-template>
          </div>
          <table-template ref="merchant"
                          :tableOptions="merchantTable"
          ></table-template>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from '@/config/api';
import userPower from "@/mixin/userPower";
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import echartsTemplate from "@/components/controls/echarts";
import {categoryEcharts, merchantEcharts, storeEcharts} from '@/page/home/options/reportEcharts'

export default {
  mixins: [userPower],
  components: {searchFormTemplate, tableTemplate, echartsTemplate},
  data() {
    let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
      param: defaultParam,
      storeEcharts,
      categoryEcharts,
      merchantEcharts,
      activeTab: 'store',
      title: '',
      indexShow: false,
      //按门店
      storeSearchOptions: {
        simple: [{
          label: '门店名称',
          type: 'select',
          data: [],
          prop: 'storeId',
          url: api.system.seStore,
        },],
      },
      toolConfig: [
        {
          label: '导出',
          code: 'export',
          callback: this.exportData
        }
      ],
      storeReportTable: {
        param: defaultParam,
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            width: '340',
            align: 'center'
          },
          {
            label: '库存量',
            prop: 'inventoryNum',
            width: '290',
            align: 'center'
          },
          {
            label: '可售总额',
            prop: 'retailMoney',
            width: '290',
            align: 'center'
          },
          {
            label: '成本总额',
            prop: 'purchaseMoney',
            width: '340',
            align: 'center'
          },
        ],
        url: api.report.reportStatical

      },
      //按分类
      categorySearchOptions: {
        simple: [
          // {
          //   label: '商品分类',
          //   type: 'cascader',
          //   prop: 'goodsCategoryId',
          //   valueKey: 'value',
          //   data: [],
          //   span: 12,
          //   url: api.archives.getCategoryTree,
          // },
          {
            label: '商品分类',
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 12,
            url: api.archives.getCategoryTree,
          },
        ],
      },
      categoryTable: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '商品分类',
            prop: 'goodsCategoryName',
            width: '340',
            align: 'center'
          },
          {
            label: '库存量',
            prop: 'inventoryNum',
            width: '290',
            align: 'center'
          },
          {
            label: '可售总额',
            prop: 'retailMoney',
            width: '290',
            align: 'center'
          },
          {
            label: '成本总额',
            prop: 'purchaseMoney',
            width: '340',
            align: 'center'
          },
        ],
        url: api.report.categoryStatical
      },
      //按供应商
      merchantSearchOptions: {
        simple: [{
          label: '供应商名称',
          type: 'select',
          prop: 'supplierId',
          data: [],
          url: api.archives.supplier
        },],
      },
      merchantTable: {
        param: defaultParam,
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '供应商名称',
            prop: 'supplierName',
            width: '260',
            align: 'center'
          },
          {
            label: '库存量',
            prop: 'inventoryNum',
            width: '220',
            align: 'center'
          },
          {
            label: '可售总额',
            prop: 'retailMoney',
            width: '220',
            align: 'center'
          },
          {
            label: '成本总额',
            prop: 'purchaseMoney',
            width: '290',
            align: 'center'
          },
        ],
        url: api.report.merchantStatical
      },

    }
  },
  created() {
    this.setStore(this.storeSearchOptions.simple);
    this.getStoreData(this.param),
      this.getCategoryData(this.param),
      this.getMerchantData(this.param)
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    //按门店
    getStoreData(param) {
      this.$axios.fetchPost(api.report.staticalEcharts, param).then(data => {
        if (data.code == 200) {
          if (data.data.storeName.length == 0) {
            this.storeEcharts.charsOption.title.text = "暂未查询到相关记录";
            this.storeEcharts.charsOption.title.top = 'center'
            this.storeEcharts.charsOption.title.left = 'center'
            this.storeEcharts.charsOption.xAxis[0].data = [];
            this.storeEcharts.charsOption.series[0].data = [];
            this.storeEcharts.charsOption.series[1].data = [];
            this.storeEcharts.charsOption.series[2].data = [];
          } else {
            this.storeEcharts.charsOption.title.text = "";
            this.storeEcharts.charsOption.title.top = 0;
            this.storeEcharts.charsOption.title.left = 0;
            this.storeEcharts.charsOption.xAxis[0].data = data.data.storeName;
            this.storeEcharts.charsOption.series[0].data = data.data.inventoryNum;
            this.storeEcharts.charsOption.series[1].data = data.data.retailMoney;
            this.storeEcharts.charsOption.series[2].data = data.data.purchaseMoney;
          }
          this.$nextTick(() => {
            this.$refs.storeEcharts.drawpic();
          });
        }
      }).catch(err => {
        this.$message({message: '请求失败！', type: 'error'})
      })
    },
    //按分类
    getCategoryData(param) {
      this.$axios.fetchPost(api.report.categorysEcharts, param).then(data => {
        if (data.code == 200) {
          this.categoryEcharts.charsOption.xAxis[0].data = data.data.categoryName;
          this.categoryEcharts.charsOption.series[0].data = data.data.inventoryNum;
          this.categoryEcharts.charsOption.series[1].data = data.data.retailMoney;
          this.categoryEcharts.charsOption.series[2].data = data.data.purchaseMoney;
          this.$nextTick(() => {
            this.$refs.categoryEcharts.drawpic()
          });
        }
      })
    },
    //按供应商
    getMerchantData(param) {
      // console.log(param)
      this.$axios.fetchPost(api.report.merchantEcharts, param).then(data => {
        if (data.code == 200) {
          this.merchantEcharts.charsOption.xAxis[0].data = data.data.supplierName;
          this.merchantEcharts.charsOption.series[0].data = data.data.inventoryNum;
          this.merchantEcharts.charsOption.series[1].data = data.data.retailMoney;
          this.merchantEcharts.charsOption.series[2].data = data.data.purchaseMoney;
          this.$nextTick(() => {
            this.$refs.merchantEcharts.drawpic();
          });
        }
      })
    },
    searchSubmit(result) {
      let storeparams = Object.assign({}, this.param, result);
      this.$refs["store"].searchSubmit(storeparams);
      this.getStoreData(storeparams);
    },
    merchantsearchSubmit(result) {
      let merchantparams = Object.assign({}, this.param, result);
      this.getMerchantData(merchantparams);
      this.$refs["merchant"].searchSubmit(merchantparams);
    },
    categorysearchSubmit(result) {
      let categoryparam = Object.assign({}, this.param, result)
      this.getCategoryData(categoryparam);
      this.$refs["category"].searchSubmit(categoryparam)
    },
    clearSearch() {
      this.getStoreData(this.param)
      this.$refs['store'].clearSearch();
      this.getMerchantData(this.param)
      this.$refs['merchant'].clearSearch();
    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    //导出
    exportData() {
      let simpleParams;
      let url;
      let fileName;
      let exportcode
      if (this.activeTab === "store") {
        simpleParams = Object.assign({}, this.param, this.$refs["storeTemplate"].getSimpleParams())
        url = api.report.storeExportData;
        fileName = '库存统计（按门店）.xls';
        exportcode = {exportCode: 'storeInventoryExport'}
      }
      if (this.activeTab === "category") {
        simpleParams = Object.assign({}, this.param, this.$refs["categoryTemplate"].getSimpleParams())
        url = api.report.categoryExportData
        fileName = '库存统计（按分类）.xls';
        exportcode = {exportCode: 'categoryInventoryExport'}
      }
      if (this.activeTab === "merchant") {
        simpleParams = Object.assign({}, this.param, this.$refs["merchantTemplate"].getSimpleParams())
        url = api.report.merchantExportData
        fileName = '库存统计（按供应商）.xls';
        exportcode = {exportCode: 'supplierInventoryExport'}
      }
      let $params = Object.assign({}, simpleParams, exportcode);
      this.$axios.fetchPost(url, $params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
  }
}
</script>

<style scoped>
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 15px 25px 25px 25px;
}

.page-template .echartsArea {
  height: 500px;
  margin-bottom: 20px;
}

.charts-box {
  height: 500px;
}

.echartsArea .charts-box-merchant {
  height: 500px;
  width: calc(100vw - 200px)
}

.charts-box-category {
  height: 500px;
  width: calc(100vw - 200px)
}
</style>



// WEBPACK FOOTER //
// src/page/report/inventory/Statistical.vue